export default "__VITE_ASSET__DeOtrxZk__"